import { render, staticRenderFns } from "./FieldGroup.vue?vue&type=template&id=2f96c6d2&"
import script from "./FieldGroup.vue?vue&type=script&lang=js&"
export * from "./FieldGroup.vue?vue&type=script&lang=js&"
import style0 from "./FieldGroup.vue?vue&type=style&index=0&id=2f96c6d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports